import {Component, OnInit} from '@angular/core';
import {Http} from '@angular/http';
import {Subscription} from 'rxjs';
 
@Component({
    selector: 'spiner',
    template: `
        <div [ngBusy]="busy"></div>
    `
})
class SomeComponent implements OnInit {
    busy: Subscription;
 
    constructor(private http: Http) {}
 
    ngOnInit() {

    }
}


// WEBPACK FOOTER //
// ./src/app/components/share/spiner.component.ts